module.exports = __webpack_public_path__ + "static/media/pop.8af11aab.mp3";